// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"2a1a7cf5","280":"b0482066","288":"c8811b1a","453":"54292a4b","599":"9a950672","623":"83c0e12e","629":"8e00c88c","951":"810651d7","967":"fed3550d","992":"0af0c08d"}[chunkId] + ".chunk.js";
};